<template>
    <div v-bind:id="id(index)" class="choix collapse col-xs-12 col-flex col-full col-last"
         v-bind:data-level="current(level)">
        <div class="inner-choix col-full row-flex">
            <div class="col-xs-12 col-flex col-full">
                <div class="p">
                    <div v-html="items[item].description"></div>
                    <hr class="hidden-xs hidden-sm">
                </div>
            </div>
            <template v-for="(option, subIndex) in items[item].options">
                <div class="col-xs-12 col-flex">
                  <a class="btn btn-gray-light btn-lg btn-block no-scroll"
                                                   v-bind:data-level="next(level)"
                                                   v-bind:data-toggle="collapse(items[option])"
                                                   v-bind:href="href(items[option], 'choix-' + index, subIndex)"
                                                   aria-expanded="false"
                                                   v-bind:target="target(items[option])"
                                                   v-bind:aria-controls="'choix-' + buildSubIndex(index, subIndex)">
                    <span v-if="items[item].steps"><span class="badge badge-primary">Etape {{subIndex + 1}} de {{items[item].options.length}}</span></span>

                    {{items[option].title}}</a>
                </div>
                <HelpItem v-bind:items="items" v-bind:item="option" v-bind:index="buildSubIndex(index, subIndex)"
                          v-bind:level="next(level)"></HelpItem>
            </template>
            <hr class="col-xs-12 hidden-md hidden-lg">
        </div>
    </div>
</template>

<script>
    export default {
        name: "HelpItem",
        props: ['items', 'item', 'index', 'level'],
        methods: {
            id: function (option) {
                return "choix-" + option;
            },
            isActive: function (option) {
                return (this.path.indexOf(option) >= 0);
            },
            target: function (item) {
                return (item.action != null ? "_blank" : null);
            },
            collapse: function (item) {
                return (item.action == null ? "collapse" : null);
            },
            buildSubIndex: function (index, subIndex) {
                return index + "-" + subIndex;
            },
            current: function (level) {
                return parseInt(level) + 0;
            },
            next: function (level) {
                return parseInt(level) + 1;
            },
            href: function (item, index, subIndex) {
                return (item.action != null ? item.action : "#" + this.buildSubIndex(index, subIndex));
            }
        }
    }
</script>

<style scoped>
.badge-success {
  color: #fff;
  background-color: #28a745;
}
.badge-primary {
  color: #fff;
  background-color: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/help/src/components/HelpItem.vue